import React, { Component } from 'react';
import Helmet from 'react-helmet';
import map from 'lodash/map';

import Image from '../components/Image';
import Video from '../components/Video';
import WorkNav from '../components/WorkNav';
import Loader from '../components/Loader';
import Animated from '../components/Animated';

import {
  wrapper,
  textContainer,
  thirdWidth,
  wideContainer,
  removePaddingVertical,
  // removePaddingTop,
} from '../styles';

const getImage = (folder, filename, i) => {
  return [
    {
      srcSet: require(`../assets/${folder}/${filename}-sm-${i}.jpg`),
      media: '(max-width: 720px)',
    },
    {
      srcSet: require(`../assets/${folder}/${filename}-${i}.jpg`),
    },
  ];
};

const getImages = (folder, filename, count) => {
  let images = [];
  for (let i = 1; i <= count; i++) {
    images.push([
      {
        srcSet: require(`../assets/${folder}/${filename}-sm-${i}.jpg`),
      },
    ]);
  }
  return images;
};

const terrainPoster = getImage('union-square', 'terrain', 4);
const fractalPlanetPoster = getImage(
  'union-square',
  'fractal-planet',
  Math.floor(Math.random() * 3 + 1)
);
const colorfragPoster = getImage('union-square', 'colorfrag', 1);
const concept4Grid = getImages('union-square', 'concept-4', 3);
const concept5Grid = getImages('union-square', 'concept-5', 3);
const concept6Grid = getImages('union-square', 'concept-6', 3);
const concept7Grid = getImages('union-square', 'concept-7', 3);
const concept8Grid = getImages('union-square', 'concept-8', 3);
// const concept9Grid = getImages('union-square', 'concept-9', 3);
const concept10Grid = getImages('union-square', 'terrain', 3);
const grids = [
  concept4Grid,
  concept5Grid,
  concept6Grid,
  concept7Grid,
  concept8Grid,
  // concept9Grid,
  concept10Grid,
];

class UnionSquare extends Component {
  componentWillMount() {
    this.props.load();
  }
  render() {
    const { content } = this.props;
    if (!content) {
      return <Loader />;
    }

    const { headerImage } = content;
    const { prev, next } = this.props;
    return (
      <div>
        <Helmet
          title="Union Square generative art installation by lucastswick"
          description="Union Square is a 6k, 2-story tall generative art installation in New York."
          meta={[
            {
              property: 'og:image:url',
              content: `https://generativeartist.com${headerImage[1].srcSet}`,
            },
            {
              property: 'twitter:image',
              content: `https://generativeartist.com${headerImage[1].srcSet}`,
            },
          ]}
        />
        <div {...textContainer}>
          <Animated as="h1">Union Square</Animated>
          <Animated delay={150}>
            A 6k generative art installation in New York
          </Animated>
          <Animated delay={300}>
            While working for the Portland Design Agency{' '}
            <a
              href="https://www.weareparliament.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Parliament
            </a>, we were tasked with creating a generative art concept for a
            client's flagship location opening in Union Square. Running 6k
            resolution and spanning two floors plus the ceiling, it was
            literally a huge feat.
          </Animated>
        </div>
        <div {...wideContainer} {...removePaddingVertical}>
          <Video videoId={'249487646'} sources={terrainPoster} />
        </div>
        <div {...textContainer}>
          <Animated as="h2">Art Direction</Animated>
          <Animated>
            The technical challenge of creating 6k content wasn't the focus of
            our efforts. Attracting people in Union Square who are used to
            putting on blinders because of media and ad saturation to slow down
            and stop for a few seconds was the <i>real</i> challenge.
          </Animated>
          <Animated>
            We decided to do the opposite of what most do when fighting for
            attention. Instead of blasting high-contrast blinky things, we
            created slow-motion, calming visuals.
          </Animated>
        </div>
        <div {...wideContainer} {...removePaddingVertical}>
          <Video videoId={'249489687'} sources={fractalPlanetPoster} />
        </div>
        <div {...textContainer}>
          <Animated as="h2">What did I do?</Animated>
          <Animated>
            My role was to write the generative art system that delivered 6k
            content. I wrote a Processing app to continuously create visuals,
            and a controller to tweak them.
          </Animated>
        </div>
        <div {...wideContainer} {...removePaddingVertical}>
          <Video videoId={'249484009'} sources={colorfragPoster} />
        </div>
        <div {...textContainer}>
          <Animated as="h2">But it wasn't easy</Animated>
          <Animated>
            One challenge was working with 6k content. The files are MASSIVE. We
            were filling a hard drive every other day!
          </Animated>
          <Animated>
            I built some render modes into the controller that allowed us to
            rapidly render concepts in low-res. It was pretty amazing to walk in
            every day to a bunch of new content the system had made, and we
            would curate the concepts to a manageable set and then render them
            at high-res.
          </Animated>
        </div>
        <div {...wrapper}>
          {map(grids, (grid, i) => {
            return map(grid, (g, j) => {
              return (
                <div key={`grid-${i}-${j}`} {...thirdWidth}>
                  <Image sources={g} />
                </div>
              );
            });
          })}
        </div>
        <div {...textContainer}>
          <Animated as="h2">I want to see it</Animated>
          <Animated>
            I'm super proud of the generative art we created. It's ambient art
            for a busy world. Next time you're in New York, check it out at
            Union Square!
          </Animated>
        </div>
        <WorkNav prev={prev} next={next} />
      </div>
    );
  }
}

export default UnionSquare;



// WEBPACK FOOTER //
// ./src/pages/UnionSquare.js